import { Parser } from "./Parser";
export class LogParser {
    constructor() {
        this._parser = new Parser();
    }
    parse(content, startIndex, linesLength) {
        return this._parser.parseLines(content, startIndex, linesLength);
    }
}
